import {api, ApiResponse} from "./api";
import {Produit} from "./apiProduits";

export interface Facture {
	id: number;
	client: string;
	numero_facture: string;
	montant_total: string;
	adresse_livraison: string;
	panier: Produit[];
	commande_id: number;
	montant_total_formate: string;
	created_at: string;
	updated_at: string;
	nb_produits: number;
}

export const getFactures = async (): Promise<Facture[]> => {
	try {
		const response = await api.get<ApiResponse<Facture[]>>('/factures');
		return response.data.data.map((facture) => ({
			...facture,
			nb_produits: facture.panier.length,
		}));
	} catch (error) {
		console.error('Erreur lors de la récupération des factures:', error);
		throw error;
	}
}

export const genererPdf = async (html: string) => {
	try {
		return await api.post("factures/générer", {
			method: "POST",
			headers: {"Content-Type": "application/json"},
			body: {html},
		}, {
			responseType: "blob",
		});
	} catch (error) {
		console.error('Erreur lors de la génération du pdf de la facture :', error);
		throw error;
	}
};